import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ActionIcon, Image, Modal } from '@mantine/core'
import { RunningAdvertisementDto } from '../../models/RunningAdvertisementDto'

interface ExpandedAdModalProps {
  ad: RunningAdvertisementDto | null
  onClose: () => void
}

export function ExpandedAdModal({ ad, onClose }: ExpandedAdModalProps) {
  return (
    <Modal
      opened={!!ad}
      onClose={onClose}
      size='90%'
      centered
      padding={0}
      withCloseButton={false}
      styles={{
        body: {
          height: '90vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 0,
          margin: 0,
          overflow: 'hidden',
          backgroundColor: 'black',
        },
        content: {
          height: '90vh',
          maxHeight: '90vh',
          overflow: 'hidden',
          backgroundColor: 'black',
        },
        inner: {
          padding: 0,
        },
      }}
    >
      <div
        style={{
          position: 'relative',
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          backgroundColor: 'black',
        }}
      >
        <ActionIcon
          variant='filled'
          radius='xl'
          onClick={onClose}
          style={{
            position: 'absolute',
            top: 16,
            right: 16,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            color: 'white',
            zIndex: 1,
          }}
        >
          <FontAwesomeIcon icon={faXmark} />
        </ActionIcon>
        {ad && (
          <div
            style={{
              width: '100%',
              height: '100%',
              maxWidth: 'calc(90vh * 16/9)',
              maxHeight: '90vh',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Image
              src={ad.imageUrl}
              alt={`Advertisement ${ad.id}`}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
              }}
            />
          </div>
        )}
      </div>
    </Modal>
  )
}
